import { AnnotationControls } from "@/components/flow/build/AnnotationControls";
import { Chip } from "@scripts/react/components/Chip";
import { useFlowState } from "@/hooks/useFlowState";
import { BuildSteps } from "@/types/flows";
import { twClassNames } from "@scripts/react/helpers/twClassNames";
import { FileCarouselLayout } from "./FileCarousel";
import { DelayedTooltip } from "@scripts/react/components/DelayedTooltip";

export const FileControls = ({
    filename,
    layout = FileCarouselLayout.DEFAULT,
    isComparisonMode = false
}: {
    filename?: string;
    layout?: FileCarouselLayout;
    isComparisonMode?: boolean;
}) => {
    const { step } = useFlowState();
    const isReviewStep = step === BuildSteps.REVIEW;
    const isShareLayout = layout === FileCarouselLayout.SHARE;

    return (
        <div
            className={twClassNames(
                "fileCarouselHeader relative z-20 h-12",
                isShareLayout && "!rounded-none"
            )}
        >
            <div className="flex min-w-0 items-center gap-2">
                {filename ? (
                    <DelayedTooltip content={filename} className="text-xs font-medium" />
                ) : (
                    <h3 className="text-xs font-medium text-primary">No file selected</h3>
                )}
                {isReviewStep && (
                    <Chip type="text" className="text-xxs">
                        Draft
                    </Chip>
                )}
            </div>
            {/* Hide AnnotationControls in comparison mode - each panel has its own controls */}
            {!isComparisonMode && <AnnotationControls />}
        </div>
    );
};
